import { render, staticRenderFns } from "./BAccommodation.vue?vue&type=template&id=95eafe9a&scoped=true&"
import script from "./BAccommodation.vue?vue&type=script&lang=js&"
export * from "./BAccommodation.vue?vue&type=script&lang=js&"
import style0 from "./BAccommodation.vue?vue&type=style&index=0&id=95eafe9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eafe9a",
  null
  
)

export default component.exports